import { useEffect, useRef } from 'react'

export const usePrevious = <T>(value: T) => {
  // Store current value in ref
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value]) // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current
}
